import { BookingDTOTransportMode, BookingDTOTransportType } from '@forto-dev/booking-v2-api'
import { Timeline } from '@freighthub/silhouette-core'
import { FC } from 'react'

import { IQuoteOption } from '../QuoteSheet/QuoteSheetOption'
import { BookingLCLSchedule } from './BookingLCLSchedule'
import { MainRouteSchedule } from './MainRouteSchedule'
import { PostRouteSchedule } from './PostRouteSchedule'
import { PreRouteSchedule } from './PreRouteSchedule'

type BookingTransportPlanProps = {
  option: IQuoteOption
  transportType: BookingDTOTransportType
  transportMode: BookingDTOTransportMode
}

type BookingFCLStationsProps = {
  option: IQuoteOption
}

const BookingFCLStations: FC<BookingFCLStationsProps> = ({ option }) => {
  const { preQuote, postQuote, mainQuote } = option.routeQuotes

  return (
    <>
      {/* -------- PRE RUN (Pre carriage) --------- */}
      <PreRouteSchedule option={option} />
      {/* -------- MAIN RUN (Main carriage) --------- */}
      <MainRouteSchedule
        mainQuote={mainQuote}
        hasPreQuote={Boolean(preQuote?.route)}
        hasPostQuote={Boolean(postQuote?.route)}
      />
      {/* --------- POST RUN (On-carriage) ----------- */}
      <PostRouteSchedule option={option} />
    </>
  )
}

export const BookingTransportPlan: FC<BookingTransportPlanProps> = ({ transportType, option, transportMode }) => {
  return (
    <Timeline>
      {transportType === 'lcl' ? (
        <BookingLCLSchedule option={option} transportMode={transportMode} />
      ) : (
        <BookingFCLStations option={option} />
      )}
    </Timeline>
  )
}
